import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_SPEEDINGS } from "../../../../common/constants/modules"

import { speedingsQueryKeys } from "./queryKeys"
import { useSpeedingsQuery } from "./useSpeedingsQueries"

export function useSpeedingsGrades(params = {}) {
    const url = "speeds/stats/average_exceed_5pct/"

    const parameters = useExtendWithSubnetworks(params, API_MODULE_SPEEDINGS)
    const queryKey = speedingsQueryKeys.grades(parameters)

    return useSpeedingsQuery(
        url,
        queryKey,
        parameters,
    )
}